import { IconProps } from "./types";
import React from "react";

export const UserIcon = ({
  className,
  fill = "currentColor",
  width = 12,
  height = 12,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 12 12"
    className={className}
    style={style}
  >
    <path
      d="M8.06227 3.37695C7.9704 4.61609 7.03102 5.62695 5.99977 5.62695C4.96852 5.62695 4.02751 4.61633 3.93727 3.37695C3.84352 2.08789 4.75759 1.12695 5.99977 1.12695C7.24196 1.12695 8.15602 2.11133 8.06227 3.37695Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.99993 7.12646C3.96087 7.12646 1.89134 8.25147 1.50837 10.3749C1.4622 10.6308 1.60704 10.8765 1.87493 10.8765H10.1249C10.3931 10.8765 10.5379 10.6308 10.4917 10.3749C10.1085 8.25147 8.039 7.12646 5.99993 7.12646Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />
  </svg>
);
